// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3sUdD","productName":"Table_productName__3G7iu"};